var map = {
	"./ALCE-SVG": 5322,
	"./ALCE-SVG.js": 5322,
	"./Canvas-SVG": 4702,
	"./Canvas-SVG.js": 4702,
	"./DUSM-SVG": 6914,
	"./DUSM-SVG.js": 6914,
	"./Floating-SVG": 1369,
	"./Floating-SVG.js": 1369,
	"./Theme-SVG": 7149,
	"./Theme-SVG.js": 7149,
	"./alce/alce-panel-advanced.svg": 1537,
	"./alce/alce-panel-basic.svg": 8076,
	"./dusm/dusm-panel.svg": 7016,
	"./floating/floating-panel.svg": 6539,
	"./theme/theme-panel.svg": 3950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;